import { TTypographySize } from './typography.types';
import { FONT_LINE_HEIGHT, FONT_SIZE } from './typography.constants';

export const getFontSize = (size?: TTypographySize) =>
    size ? FONT_SIZE[size] : FONT_SIZE.p;

export const getLineHeight = (size?: TTypographySize) =>
    size ? FONT_LINE_HEIGHT[size] : FONT_LINE_HEIGHT.p;
